/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-01-17 15:03:45
 *
 *******************************************************/
// @flow

import React, { useEffect, useState } from 'react';
import { Button, TextStyle } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { getShop } from 'src/helpers';
import { URL } from 'src/constants/links';

import rocketIcon from 'assets/images/common/rocket-icon.png';

type Props = WithI18nProps & {
  name: string,
  feature: string,
  learnMoreLink: string
};
// DONE
const PromoteBanner = (props: Props) => {
  const { i18n, name, feature, learnMoreLink } = props;
  const [active, setActive] = useState(true);

  useEffect(() => {
    // Check show info banner
    let dismiss = false;
    try {
      dismiss = localStorage.getItem(`${getShop()}-dismiss${name}`);
    } catch (error) {}

    // If the banner is dismissed, hide it
    if (dismiss === 'true') {
      setActive(false);
    }
  }, [name]);

  // Handle dismiss info banner
  const onDismiss = () => {
    try {
      localStorage.setItem(`${getShop()}-dismiss${name}`, true);
    } catch (error) {}
    setActive(false);
  };

  if (!active) return null;

  return (
    <div className="promote-banner">
      <img width={20} height={20} alt="pfs-rocket-icon" src={rocketIcon} />
      <p>
        {i18n.translate(`AdminHTML.${feature}.PromoteBanner.content`, {
          t1: (
            <TextStyle variation="strong">
              {i18n.translate(`AdminHTML.${feature}.PromoteBanner.content_t1`)}
            </TextStyle>
          ),
          t2: (
            <a href={URL[learnMoreLink]} target="_blank" rel="noopener noreferrer">
              {i18n.translate(`AdminHTML.${feature}.PromoteBanner.content_t2`)}
            </a>
          )
        })}
      </p>
      <Button onClick={onDismiss} icon={MobileCancelMajor} plain />
    </div>
  );
};

export default withI18n()(PromoteBanner);
